import { createReducer } from '../../utils/createReducer';
import {
  GET_RETAIL_PLAN_INPUTS_ERROR,
  GET_RETAIL_PLAN_INPUTS_SUCCESS,
  GET_RETAIL_PLAN_INPUTS,
  UPDATE_RETAIL_MASTER_PLAN_INPUTS,
  GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA,
  GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA_SUCCESS,
} from './constants';

const INITIAL_STATE = {
  retailPlanInputsData: {},
  retailPlanInputsError: '',
  retailPlanInputsLoading: false,
  retailProductionPlanTabMetadata: {
    initialised: false,
    loading: false,
    error: false,
    data: { list: [] },
  },
};

const retailProductionPlanningReducer = {
  [GET_RETAIL_PLAN_INPUTS]: (state, action) => {
    return {
      ...state,
      retailPlanInputsData: {},
      retailPlanInputsLoading: true,
    };
  },
  [GET_RETAIL_PLAN_INPUTS_SUCCESS]: (state, action) => {
    return {
      ...state,
      retailPlanInputsData: action.payload,
      retailPlanInputsLoading: false,
    };
  },
  [GET_RETAIL_PLAN_INPUTS_ERROR]: (state, action) => {
    return {
      ...state,
      retailPlanInputsError: action.payload,
      retailPlanInputsLoading: false,
    };
  },
  [UPDATE_RETAIL_MASTER_PLAN_INPUTS]: (state, { payload }) => {
    return {
      ...state,
      retailPlanInputsData: {
        ...state.retailPlanInputsData,
        inputMetadata: state.retailPlanInputsData.inputMetadata.map((input) => {
          if (input.id === payload.id) {
            return { ...input, lastUpdatedAt: payload.lastUpdatedAt };
          } else {
            return input;
          }
        }),
      },
    };
  },
  [GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA]: (state, action) => {
    return {
      ...state,
      retailProductionPlanTabMetadata: {
        ...state.retailProductionPlanTabMetadata,
        loading: true,
        error: false,
      },
    };
  },
  [GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA_SUCCESS]: (state, action) => {
    return {
      ...state,
      retailProductionPlanTabMetadata: {
        ...state.retailProductionPlanTabMetadata,
        initialised: true,
        loading: false,
        ...action.payload,
      },
    };
  },
};

export default createReducer(INITIAL_STATE, retailProductionPlanningReducer);
